import { call, put, takeLatest } from "redux-saga/effects";
import { SPSELECTS } from "../../InterfacesTypes/enums";
import { spGet } from "../../utils/SharepointAPI";
import { getEnvironment } from "../../utils/utils";
import type { IHeroImage } from "InterfacesTypes/interfaces";
import {
  fetchFailure,
  fetchImages,
  fetchStart,
  fetchSuccess,
} from "state/reducers/HeroImageReducer";

const env = getEnvironment();
function* fetchHeroImagesWorker() {
  try {
    yield put(fetchStart());
    const imageUrl = `${env.listapi}/GetByTitle('HeroImages')/Items?$top=5000&$select=${SPSELECTS.HEROIMAGES}`;
    const data: IHeroImage[] = yield call(spGet, imageUrl);
    yield put(fetchSuccess(data));
  } catch (err: any) {
    yield put(fetchFailure(err?.message ?? "Något gick fel"));
  }
}

export function* heroImageSaga() {
  yield takeLatest(fetchImages.type, fetchHeroImagesWorker);
}
